import { Loading } from '@/components/Loading/Loading'
import { AddToCartType } from '@/constants'
import { useTranslations } from 'next-intl'
import { useRef, useState } from 'react'

interface ProductButtonType {
  type: string
  isProcessing?: boolean
  text?: string
  className?: string
  onClick: () => void
  isPreOrderButton?: boolean
  date?: number
}
export const ProductButton = ({
  type,
  className = '',
  text = '',
  onClick,
  isProcessing,
  isPreOrderButton = false,
  date,
}: ProductButtonType) => {
  const buttonRef = useRef(null)
  const [id, setId] = useState('')
  const t = useTranslations('ProductDetail')
  const renderBtn = (e: string) => {
    switch (e) {
      case 'add-to-cart':
        return {
          primary: t('addToCart'),
          second: t('addToCartDesc'),
          styleBtn: 'border border-dark-900',
          stylePrimary: 'text-dark-900',
          styleSecond: 'text-dark-900',
        }
      case 'contact':
        return {
          primary: t('reserve'),
          second: t('leaveYourInfo'),
          styleBtn: 'border border-primary-second',
          stylePrimary: 'text-primary-second',
          styleSecond: 'text-primary-second',
        }
      case 'outOfBusiness':
        return {
          primary: 'Ngừng kinh doanh',
          second: '',
          styleBtn: 'border border-dark-200/50 pointer-events-none',
          stylePrimary: 'text-dark-400/50',
          styleSecond: 'text-dark',
        }
      case 'buy-now':
        return {
          primary: t('buyNow'),
          second: t('buyNowDesc'),
          styleBtn: 'bg-primary-base border border-primary-base',
          stylePrimary: 'text-white',
          styleSecond: 'text-white',
        }
      case AddToCartType.PRE_ORDER:
        return {
          primary: 'Đặt trước',
          second: 'Giao hàng sau ',
          subSecond: ' ngày',
          styleBtn: 'bg-primary-second border border-primary-second',
          stylePrimary: 'text-white',
          styleSecond: 'text-white',
        }
      case 'installment':
        return {
          primary: t('installment'),
          second: t('installmentDesc'),
          styleBtn: 'bg-blue border-blue',
          stylePrimary: 'text-white',
          styleSecond: 'text-white',
        }
      case 'pay-late':
        return {
          primary: t('payLater'),
          second: t('payLaterDesc'),
          styleBtn: 'bg-blue border-blue',
          stylePrimary: 'text-white',
          styleSecond: 'text-white',
        }

      default:
        return {
          primary: '',
          second: '',
          styleBtn: '',
          stylePrimary: '',
          styleSecond: '',
        }
    }
  }
  return (
    <button
      type='button'
      ref={buttonRef}
      id={type}
      onClick={ev => {
        setId(ev.currentTarget.id)
        onClick()
      }}
      disabled={isProcessing && id === type}
      className={`${className} ${
        renderBtn(type)?.styleBtn
      } flex h-[64px] w-full flex-wrap content-center items-center justify-center gap-0 rounded-lg text-sm text-dark-900`}
    >
      <span
        className={`${
          renderBtn(type)?.stylePrimary
        } mt-[4px] block w-full text-[20px] font-bold uppercase leading-6`}
      >
        {isProcessing && id === type ? <Loading /> : renderBtn(type)?.primary}
      </span>

      <>
        {isPreOrderButton ? (
          <span
            className={`${renderBtn(type)?.styleSecond} block w-full text-sm`}
          >
            {text
              ? text
              : renderBtn(type)?.second + date + renderBtn(type)?.subSecond}
          </span>
        ) : (
          <span
            className={`${renderBtn(type)?.styleSecond} block w-full text-sm`}
          >
            {text ? text : renderBtn(type)?.second}
          </span>
        )}
      </>
    </button>
  )
}
export default ProductButton
